module.exports = __webpack_public_path__ + "static/media/question_mark.68c4369c.svg";